import { createI18n, resolveLanguage } from "@luckymenu/i18n";

export const i18n = createI18n(resolveLanguage(navigator.languages));
